import { Instance } from 'mobx-state-tree'
import { UserGamesModelBase } from './UserGamesModel.base'

/* The TypeScript type of an instance of UserGamesModel */
export interface UserGamesModelType extends Instance<typeof UserGamesModel.Type> {}

/* A graphql query fragment builders for UserGamesModel */
export { selectFromUserGames, userGamesModelPrimitives, UserGamesModelSelector } from './UserGamesModel.base'

/**
 * UserGamesModel
 */
export const UserGamesModel = UserGamesModelBase.actions((self) => ({
  // This is an auto-generated example action.
  log() {
    console.log(JSON.stringify(self))
  }
}))
